import axios from '@/config/axios'

const invoiceBase = '/v1/api/mg/prove/invoice'

export const invoiceList = (query) => axios.get(`${invoiceBase}`, {params: query});


export const exportInvoiceList = (query) => axios.get(`${invoiceBase}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
});


const receiptsBase = '/v1/api/mg/prove/receipts'


export const receiptList = (query) => axios.get(`${receiptsBase}`, {params: query});


export const exportReceiptList = (query) => axios.get(`${receiptsBase}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
});


export const downloadFile = (docNo) => axios.get(`/v1/api/mg/prove/download/${docNo}`, {responseType: 'arraybuffer'})
